import { render, staticRenderFns } from "./mzHerbalDetail.vue?vue&type=template&id=acaa7326&scoped=true"
import script from "./mzHerbalDetail.vue?vue&type=script&lang=js"
export * from "./mzHerbalDetail.vue?vue&type=script&lang=js"
import style0 from "./mzHerbalDetail.vue?vue&type=style&index=0&id=acaa7326&prod&scoped=true&lang=css"
import style1 from "./mzHerbalDetail.vue?vue&type=style&index=1&id=acaa7326&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaa7326",
  null
  
)

export default component.exports